<template>
  <mcw-card class="stuchalka-popup" style="width: 350px;">
    <mcw-card-primary-action>
      <div class="card-header">
        <p>Пациент: {{ selectedPatient.fio }}</p>
        <p>
          Баланс:
          <span :style="{ color: selectedStatusBar?.balance < 0 ? '#ff5252' : 'inherit' }">
            {{ selectedStatusBar?.balance ?? '-/-' }}
          </span>
          <mcw-material-icon icon="currency_ruble" style="font-size: 12px;"/>
        </p>
      </div>
    </mcw-card-primary-action>

    <section style="min-height: 150px; max-height: 50vh; overflow-y: auto;">
      <mcw-list v-if="selectedStatusBar?.nastuchat" style="max-height: 250px; overflow-y: auto;">
        <mcw-list-item
          v-for="(item, index) in selectedStatusBar.nastuchat.split(';')"
          :key="index"
        >
          {{ item }}
        </mcw-list-item>
      </mcw-list>

      <mcw-textfield
        v-model="textStuchalka"
        label="Что стоит знать о пациенте?"
        outlined
        fullwidth
        multiline
        helper="Предупредим коллег"
        :rows="2"
      />

      <section>
        <mcw-checkbox
          v-model="adminNotify"
          input-id="admin-notify"
        />
        <label for="admin-notify">Старшему администратору на почту</label>
      </section>
    </section>

    <mcw-card-actions style="justify-content: flex-end;">
      <mcw-button
        unelevated
        @click="$emit('close')"
      >
        Закрыть
      </mcw-button>
      <mcw-button
        raised
        :disabled="!textStuchalka"
        @click="sendReport"
        style="margin-left: 10px;"
      >
        Отправить
      </mcw-button>
    </mcw-card-actions>
  </mcw-card>
</template>

<script>
export default {
  name: 'StuchalkaPopup',
  props: {
    selectedPatient: {
      type: Object,
      required: true,
    },
    selectedStatusBar: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      textStuchalka: '',
      adminNotify: false,
    };
  },
  methods: {
    sendReport() {
      this.$emit('send-report', {
        text: this.textStuchalka,
        notifyAdmin: this.adminNotify,
      });
    },
    clear() {
      this.textStuchalka = '';
      this.adminNotify = false;
    },
  },
};
</script>
